module.exports = __webpack_public_path__ + "static/media/linkedin-in-brands.7d453db7.svg";